import { render, staticRenderFns } from "./AllPrivileges.vue?vue&type=template&id=0cc705d9&"
import script from "./AllPrivileges.vue?vue&type=script&lang=js&"
export * from "./AllPrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports